import { AgentIntegrationsChatbot } from './agent-integrations-chatbot';

type AgentIntegrationHubProps = {
  id: string;
  allowedDomainsInput: string;
  onAllowedDomainsInputChange: (value: string) => void;
};

export const AgentIntegrationHub = ({
  id,
  allowedDomainsInput,
  onAllowedDomainsInputChange,
}: AgentIntegrationHubProps) => {
  return (
    <AgentIntegrationsChatbot
      agentId={id}
      allowedDomainsInput={allowedDomainsInput}
      onAllowedDomainsInputChange={onAllowedDomainsInputChange}
    />
  );
};
